function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ComorsFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("path", {
    fill: "#5196ED",
    fillRule: "evenodd",
    d: "M0 0v24h24V0H0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "24",
    x: "0",
    y: "0",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M0 0v24h24V0H0Z",
      clipRule: "evenodd"
    })
  }), /*#__PURE__*/_jsxs("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#AF0100",
      d: "M0 12v6h24v-6H0Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#F7FCFF",
      d: "M0 6v6h24V6H0Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#FBCD17",
      d: "M0 0v6h24V0H0Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#5EAA22",
      d: "m0 0 12 12L0 24V0Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#F7FCFF",
      d: "M4.728 17.456s-2.687-1.334-2.592-5.511c.095-4.177 2.832-4.996 2.832-4.996C4.009 5.943.58 7.122.47 11.945c-.11 4.822 3.237 5.893 4.258 5.51Zm.143-7.17.101-.786-.428-.556.592-.115.264-.714.265.714.591.115-.428.556.101.785-.529-.37-.529.37Zm.101 1.214-.101.785.529-.37.529.37-.101-.785.428-.556-.591-.115-.265-.714-.264.714-.592.115.428.556Zm-.101 2.785.101-.785-.428-.556.592-.115.264-.714.265.714.591.115-.428.556.101.785-.529-.37-.529.37Zm0 2 .101-.785-.428-.556.592-.115.264-.714.265.714.591.115-.428.556.101.785-.529-.37-.529.37Z"
    })]
  })]
}));
//# sourceMappingURL=Comors.js.map